import React, { ReactNode, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  CreateItem,
  OrderPayload,
  Workout,
} from "src/modules/fithub-shared/interfaces/workout";
import api, { rqueryclient } from "src/rest/api";
import CreateModal from "../CreateModal";
import WorkoutView from "../WorkoutView";
import Tabs from "../WorkoutView/Tabs";

const WorkoutWrapper: React.FC<{ protocol: string; children: ReactNode }> = ({
  protocol,
  children,
}) => {
  const [selected, setSelected] = useState<string>();
  const [create, setCreate] = useState(false);

  const { data: workouts, refetch } = useQuery(["workouts", protocol], () =>
    api
      .post<Workout[]>("/workouts/list", { protocol })
      .then((res) => res.data)
      .catch((err) => {
        throw new Error(err);
      }),
  );

  const mutateChanges = useMutation(
    (update: Workout) => api.post<Workout>("/workouts/save", update),
    {
      onSuccess: ({ data }) => {
        rqueryclient.setQueryData<Workout[]>(
          ["workouts", protocol],
          (oldData) => {
            if (!oldData) return [];

            return oldData.map((workout) =>
              workout.id === data.id ? data : workout,
            );
          },
        );
      },
    },
  );

  const mutateOrder = useMutation(
    (update: Workout[]) =>
      api.post<OrderPayload>("/workouts/update-order", {
        order: update.map(({ id, order }) => ({ id, order })),
      }),

    {
      onSuccess: ({ data }) => {
        rqueryclient.setQueryData<Workout[]>(
          ["workouts", protocol],
          (oldData) => {
            if (!oldData) return [];

            return oldData.map((workout) => {
              const updatedOrder = data.find((item) => item.id === workout.id);
              return updatedOrder
                ? { ...workout, order: updatedOrder.order }
                : workout;
            });
          },
        );
      },
    },
  );

  const workout = workouts?.find((e) => selected === e.id);
  const unselect = () => setSelected(undefined);

  function onCreate(type: number) {
    if (!workouts) return;

    const count = workouts.filter((e) =>
      e.title.startsWith("Novo Treino"),
    ).length;

    api
      .post<Workout>("/workouts/create", {
        protocol,
        type: type,
        item: CreateItem(type),
        title: `Novo Treino ${count + 1}`,
        order: workouts.length,
      })
      .then((res) => {
        refetch();
        setSelected(res.data.id);
        setCreate(false);
      });
  }

  return (
    <>
      {create ? (
        <CreateModal create={onCreate} />
      ) : workouts && workout ? (
        <WorkoutView
          workout={workout}
          unselect={unselect}
          mutation={mutateChanges}
        />
      ) : (
        <>{children}</>
      )}

      <Tabs
        handleCreate={() => setCreate(true)}
        create={create}
        reload={refetch}
        workouts={workouts}
        selected={selected}
        select={setSelected}
        onReorder={mutateOrder}
      />
    </>
  );
};

export default WorkoutWrapper;
